var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    transform: "translate(0.652344 0.5)",
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6523 6.5C11.6523 9.26142 9.41377 11.5 6.65234 11.5C3.89092 11.5 1.65234 9.26142 1.65234 6.5C1.65234 3.73858 3.89092 1.5 6.65234 1.5C9.41377 1.5 11.6523 3.73858 11.6523 6.5ZM5.34354 6.03446C5.40455 6.06066 5.45972 6.09876 5.50584 6.14651L6.15234 6.79301L7.79884 5.14651C7.84497 5.09876 7.90014 5.06066 7.96114 5.03446C8.02214 5.00826 8.08775 4.99446 8.15414 4.99388C8.22053 4.99331 8.28637 5.00596 8.34782 5.0311C8.40927 5.05624 8.46509 5.09337 8.51204 5.14031C8.55899 5.18726 8.59611 5.24309 8.62125 5.30453C8.64639 5.36598 8.65904 5.43182 8.65847 5.49821C8.65789 5.5646 8.6441 5.63021 8.61789 5.69121C8.59169 5.75221 8.5536 5.80739 8.50584 5.85351L6.50584 7.85351C6.41208 7.94725 6.28492 7.9999 6.15234 7.9999C6.01976 7.9999 5.89261 7.94725 5.79884 7.85351L4.79884 6.85351C4.75109 6.80739 4.713 6.75221 4.68679 6.69121C4.66059 6.63021 4.64679 6.5646 4.64622 6.49821C4.64564 6.43182 4.65829 6.36598 4.68343 6.30453C4.70857 6.24308 4.7457 6.18726 4.79264 6.14031C4.83959 6.09337 4.89542 6.05624 4.95687 6.0311C5.01831 6.00596 5.08415 5.99331 5.15054 5.99389C5.21693 5.99446 5.28254 6.00826 5.34354 6.03446Z",
    fill: "#09A55A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.8c85691be6bc40be1f60305ee74a6b28.svg";
export { ForwardRef as ReactComponent };